/**
 * @param {object} doctorLocation
 * @returns {string}
 */
export default function getDoctorLocationId(doctorLocation) {
    const profId = doctorLocation.professional.professional_id;
    const locId = doctorLocation.location.location_id;
    const adServedEventId = doctorLocation.ad_served_event_id;
    const spoAdDecisionId = doctorLocation.spo_ad_decision_id;
    const adServedEventIdPostfix = !!adServedEventId ? `_${adServedEventId}` : '';
    const spoAdDecisionIdPostFix = !!spoAdDecisionId ? `_${spoAdDecisionId}` : '';

    return `${profId}_${locId}${adServedEventIdPostfix}${spoAdDecisionIdPostFix}`;
}
